import { render } from "./AllOfTopScreen.vue?vue&type=template&id=4f63f49a&scoped=true&ts=true&lang=pug"
import script from "./AllOfTopScreen.vue?vue&type=script&lang=ts"
export * from "./AllOfTopScreen.vue?vue&type=script&lang=ts"

import "./AllOfTopScreen.vue?vue&type=style&index=0&id=4f63f49a&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f63f49a"]])

export default __exports__